import { logger } from '../../../../utils/logger';
import { cxoneSdkState } from '../../state';

export async function preWarmMediaAccess(): Promise<void> {
  logger.debug('[CXone SDK] Pre-warming media access...');

  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });

    cxoneSdkState.preWarmedMediaStream = stream;
    logger.debug('[CXone SDK] Media stream pre-warmed successfully');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__cxoneSdkState.preWarmedMediaStream = stream;
  } catch (error) {
    logger.warn('[CXone SDK] Failed to pre-warm media access:', error);
  }
}
